import React, { useState } from 'react';
import DeptInput from './DebtInput'

import { payoffOrder } from '../consts'
import { calcDebtPayoff } from '../libs/finCalcs'

// material UI
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button'
import { isFlowBaseAnnotation } from '@babel/types';
import { makeStyles } from '@material-ui/core/styles';
import PayoffSchedule from './PayoffSchedule'
import PayoffSummary from './PayoffSummary'
import PayoffPDF from './PayoffPDF'

const SCHEDULE = false;
const SUMMARY = true;

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    tableWrapper: {
        maxHeight: 440,
        overflow: 'auto',
    },
});

function PayoffOutput(props) {

    const classes = useStyles();

    const [mode, setMode] = useState(SUMMARY)
    const [pdf, setPdf] = useState(false)

    const switchMode = () => {

        setMode(!mode)

    }

    const togglePDF = () => {

        setPdf(!pdf)

    }

    return (
        <div>
            <Button
                style={{marginRight: "8px"}}
                color='primary'
                variant="contained"
                onClick={switchMode}
            >
                {
                    mode === SCHEDULE ? (
                        "Show Summary"
                    ) : (
                            "Show Detail"
                        )
                }
            </Button>
            <Button
                color='primary'
                variant="contained"
                onClick={togglePDF}
            >
                {
                    pdf ? (
                        "Show Page"
                    ) : (
                        "Show PDF"
                    )
                }

            </Button>
            <div>
            {
                pdf ? (
                    <PayoffPDF schedules={props.schedules}></PayoffPDF>
                ) : (
                        <React.Fragment>
                            {
                                mode === SUMMARY ? (
                                    <PayoffSummary summary={props.schedules.summary}></PayoffSummary>
                                ) : (
                                        <PayoffSchedule schedule={props.schedules.schedule} switchMode={props.switchMode} debts={props.debts}></PayoffSchedule>
                                    )
                            }
                        </React.Fragment>
                    )
            }
            </div>
        </div >
    );
}

export default PayoffOutput;